import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const InstallPWAPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        setShowPrompt(false);
        setDeferredPrompt(null);
      });
    }
  };

  if (!showPrompt) return null;

  return (
    <Modal isOpen={showPrompt} toggle={() => setShowPrompt(false)}>
      <ModalHeader toggle={() => setShowPrompt(false)}>Install Our App</ModalHeader>
      <ModalBody>
        Would you like to install our app for a better experience?
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleInstall}>Install</Button>
        <Button color="secondary" onClick={() => setShowPrompt(false)}>Not Now</Button>
      </ModalFooter>
    </Modal>
  );
};

export default InstallPWAPrompt;
